import { useTitle } from 'contexts/TitleContext'
import PropTypes from 'prop-types'
import { useEffect } from 'react'

export default function ColumnFilter({ column }) {
  const { title } = useTitle()

  // Desestructurar propiedades de 'column'
  const { filterValue, setFilter } = column

  // Obtener el filtro previo desde localStorage
  const previousFilter = localStorage.getItem(column.id)

  // Guarda el filtro actual en localStorage
  useEffect(() => {
    localStorage.setItem(column.id, filterValue)
  }, [previousFilter, filterValue])

  // Carga el filtro previo
  useEffect(() => {
    if (previousFilter !== 'undefined') {
      setFilter(previousFilter)
    }
  }, [title])

  return column.filterType === 'select' ? (
    <div className="print:hidden">
      <select
        className={`w-full py-1 pr-1 border border-gray-200 focus:ring-opacity-20 focus:outline-none focus:ring focus:border-gray-400 focus:ring-gray-300 dark:focus:border-gray-300 hover:border-gray-300 rounded-sm px-1 text-gray-400 text-sm cursor-pointer`}
        placeholder="Filtrar..."
        onClick={(e) => e.stopPropagation()}
        onChange={(e) => setFilter(e.target.value)}
      >
        <option value="">--Seleccionar--</option>
        <option value="1">Sí</option>
        <option value="0">No</option>
      </select>
    </div>
  ) : (
    <div className="print:hidden">
      <input
        type="text"
        className={`w-full py-1 pr-1 border border-gray-200 focus:ring-opacity-20 focus:outline-none focus:ring focus:border-gray-400 focus:ring-gray-300 dark:focus:border-gray-300 hover:border-gray-300 rounded-sm px-1 text-gray-400 text-sm`}
        placeholder="Filtrar..."
        onClick={(e) => e.stopPropagation()}
        onChange={(e) => setFilter(e.target.value)}
        value={filterValue || ''}
      />
    </div>
  )
}

ColumnFilter.propTypes = {
  column: PropTypes.object.isRequired
}
